import React from 'react'
import FormInput from '../../../library/form/components/FormInput';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormROValue from '../../../library/form/components/FormROValue1';
import * as fn from "../../../helper/uiFunctions";

const InvBudgetBreakupRow = (props) => {
    const { formObject, viewData, rowKey } = props;

    if (fn.compareNumber(viewData.dataList.isEditMode, 1)) {
        return (
            <div id="sectioneditorContainer" >
                <ul className="uiBudgetBrkupEditLine">
                    <li className="uiColumnCenter uiColumn70">
                        <span id="invBudgetId"  />
                        <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "invBudgetId" }} style={{ width: "60px" }} />
                    </li>
                    <li className="uiColumnCenter uiColumn200">
                        <FormInput formObject={formObject} rowKey={rowKey}
                            action={{ InputType: "ac", paramName: "invBudgetCode", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            className="uiAutoCompleteInput" style={{ width: "150px" }}
                        />
                    </li>
                    <li className="uiColumnCenter uiColumn200">
                        <FormInput formObject={formObject} rowKey={rowKey}
                            action={{ InputType: "ac", paramName: "invCostCenter", acMethod: "CategoryDetail", acDepCtrl: { dparam: '%dataList.valLCat' } }}
                            className="uiAutoCompleteInput" style={{ width: "150px" }}
                        />
                    </li>
                    <li className="uiColumnCenter uiColumn70">
                        <FormInput formObject={formObject} rowKey={rowKey} style={{ width: "70px" }} maxlength="24"
                            action={{ InputType: "input", actionId: "refresh", paramName: "invBudgetPercent", actionParam: { updateBudgetAmount: 1 } }}
                        />
                    </li>
                    <li className="uiColumnCenter uiColumn150">
                        <FormInput formObject={formObject} rowKey={rowKey} style={{ width: "150px" }}
                                action={{ InputType: "input", paramName: "invBudgetAmount" }}
                            />
                    </li>
                    <li className="uiColumnCenter uiColumn150">
                        <FormInput formObject={formObject} rowKey={rowKey} style={{ width: "150px" }} maxlength="1000"
                            action={{ InputType: "input", paramName: "invBudgetComment" }}
                        />
                    </li>
                    <li className="uiColumnCenter uiColumn70 uiActionBlock">
                        <FormButton formObject={formObject} rowKey={rowKey}
                            starIcon="confirm"
                            onlyIcon={true}
                            tooltip="Confirm Changes"
                            starIconClassName="uiColorNeutralAction"
                            action={{ actionId: "save",  actionParam: {}, containerKey: "row" }}
                            className="" ></FormButton>

                        <FormButton formObject={formObject} rowKey={rowKey}
                            starIcon="cancel"
                            onlyIcon={true}
                            tooltip="Cancel Changes"
                            starIconClassName="uiColorNegativeAction"
                            action={{ actionId: "cancel",  actionParam: {}, containerKey: "row" }}
                            className="" ></FormButton>
                    </li>
                </ul>
            </div>
        )
    }
    else {
        return (
            <ul >
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "invBudgetId" }} />
                </li>
                <li className="uiColumnCenter uiColumn200" >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "invBudgetCode" }} />
                </li>
                <li className="uiColumnCenter uiColumn200" >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "invCostCenter" }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "invBudgetPercent" }} />
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "invBudgetAmount" }} />
                </li>
                <li className="uiColumnCenter uiColumn150">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "invBudgetComment" }} />
                </li>

                <li className="uiColumnCenter uiColumn70 uiActionBlock" >
                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="edit"
                        onlyIcon={true}
                        tooltip="Edit"
                        starIconClassName="uiColorNeutralAction"
                        action={{ actionId: "edit",  actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>

                    <FormButton formObject={formObject} rowKey={rowKey}
                        starIcon="clear"
                        onlyIcon={true}
                        tooltip="Delete"
                        starIconClassName="uiColorNegativeAction"
                        action={{ actionId: "del",  actionParam: {}, containerKey: "row" }}
                        className="" ></FormButton>

                </li>
            </ul>
        )
    }
}

export default InvBudgetBreakupRow